/* eslint-disable no-nested-ternary */
import CircularProgress from '@mui/material/CircularProgress';
import { useErrorContext } from '@qpr/client-library';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import DiagramContent from '../components/DiagramContent';
import DocumentsContent from '../components/DocumentsContent';
import MetricsContent from '../components/MetricsContent';
import PropertiesCard from '../components/PropertiesCard';
import PropertiesContent from '../components/PropertiesContent';
import RelatedElementsContent from '../components/RelatedElementsContent';
import { Data } from '../properties-state';
import createPropertiesViewModel, {
  PropertiesViewModelType,
  Property
} from './properties-view-model';

interface PropertiesViewProps {
  itemId?: string;
  path?: string;
  onClose: () => void;
  name?: string;
  customProperties?: Property[];
}

const PropertiesView = ({
  itemId,
  path,
  name,
  customProperties = [],
  onClose
}: PropertiesViewProps) => {
  const [data, setData] = useState<Data>();
  const [fullscreen, setFullscreen] = useState<boolean>(false);
  const { setError } = useErrorContext();

  const { search } = useLocation();
  const queryString = new URLSearchParams(search);
  const viewDefinitionId = queryString.get('viewdefinitionid');

  const defaultProperties: Property[] = [{ attributeName: 'Description' }];

  const propertyList: Property[] = [...defaultProperties, ...customProperties];

  const viewModel: PropertiesViewModelType = createPropertiesViewModel({
    propertyList,
    id: itemId || ''
  });

  const toggleFullscreen = () => {
    setFullscreen(!fullscreen);
  };

  useEffect(() => {
    const initData = async () => {
      setData(undefined);
      const gotData = await viewModel.getData();
      setData(gotData.data);
      if (gotData.error?.message) setError(gotData.error);
    };
    if (itemId) initData();
  }, [itemId]);

  const description = data?.properties?.Description;

  const propertiesData: any = { ...data?.properties };

  delete propertiesData.Description;

  return (
    <PropertiesCard
      path={path}
      name={name}
      description={description}
      onClose={onClose}
      toggleFullscreen={toggleFullscreen}
      fullscreen={fullscreen}
    >
      {data ? (
        !fullscreen ? (
          <>
            <PropertiesContent properties={propertiesData} />
            <div style={{ marginTop: '8px' }}>
              {viewDefinitionId && itemId ? (
                <RelatedElementsContent viewDefinitionId={viewDefinitionId} elementId={itemId} />
              ) : null}
              <DocumentsContent documents={data.documents} />
              <MetricsContent measure={data.measures} />
              {data.diagram?.flowchartImageUrl !== undefined ? (
                <DiagramContent diagram={data.diagram} toggleFullscreen={toggleFullscreen} />
              ) : null}
            </div>
          </>
        ) : (
          <img
            src={data.diagram?.flowchartImageUrl}
            alt="diagram-img"
            data-testid="fullscreen-diagram"
            style={{
              display: 'block',
              margin: 'auto',
              maxWidth: '100%'
            }}
          />
        )
      ) : (
        <div style={{ width: '40px', margin: 'auto' }}>
          <CircularProgress />
        </div>
      )}
    </PropertiesCard>
  );
};

export default PropertiesView;
